import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import WhyBrand from "../media/Why Brand.avif";
import PremiumService from "../media/Premium Service.avif";
import TimelyDeliveries from "../media/Timely Deliveries.jpg";
import OurPromise from "../media/Our Promise.avif";
import Img1 from "../media/img1.avif";
import Img2 from "../media/img2.avif";
import Img3 from "../media/img3.avif";
import Img4 from "../media/img4.avif";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const OurStory = () => {
  return (
    <>
      <Header />
      <main className="our-story font-sans">
        {/* Hero Section */}
        <motion.section
          className="bg-brand pt-36 md:pt-44 text-white py-20 text-center"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <h1 className="text-5xl font-bold">Our Story</h1>
        </motion.section>

        {/* Bridging Borders */}
        <motion.section
          className="max-w-6xl mx-auto px-6 py-16"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-[#BF5717] text-center mb-6">
            Bridging Borders
          </h2>
          <p className="text-center font-bold leading-snug text-lg text-black"> The Story of Our Apparel Sourcing Agency </p>
          <p className="text-center  leading-snug text-lg text-gray-700"> In the fast-paced world of fashion, brands are constantly seeking cost-effective production solutions without compromising on quality, ethics, or timely deliveries. However, when venturing into third-world countries for apparel manufacturing, many brands face immense challenges—language barriers, cultural differences, lack of transparency, and logistical nightmares. </p>
           <p className="text-center leading-snug text-lg text-gray-700"> We saw it firsthand. </p> 
           <p className="text-center leading-snug text-lg text-gray-700"> Years ago, while working closely with brands and factories, we noticed a recurring problem. Designers and business owners, eager to bring their visions to life, struggled to navigate the complex production landscape in developing countries. Miscommunication led to delays, quality concerns, and financial losses. Many brands hesitated to manufacture abroad due to the risks involved. On the other side, factories—many of them highly skilled and capable—found it difficult to connect with international clients in a way that built trust and long-term partnerships. </p>
           <p className="text-center leading-snug text-lg text-gray-700"> That's when we stepped in. </p>
           <p className="text-center leading-snug text-lg text-gray-700"> We founded our service agency with a clear mission: to bridge the gap between brands and factories, ensuring smooth, transparent, and efficient apparel production. We knew that with the right approach, apparel sourcing in third-world countries could be a game-changer for brands, offering competitive pricing, exceptional craftsmanship, and ethical production. But it had to be done the right way. </p>
        </motion.section>

        {/* Why Brands Need Us */}
        <motion.section
          className="bg-orange-50 py-16"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center px-6">
            <div>
              <h2 className="text-3xl font-bold text-[#BF5717] mb-4">
                Why Brands Need Us
              </h2>
              <h3 className="text-xl text-black font-semibold mb-2">
                Language & Cultural Barriers
              </h3>
              <p className="mb-6 text-gray-700">
                Communication is at the heart of every successful production. Without a local team that understands both sides, messages get lost in translation, expectations are misaligned, and the result is frustration on both ends. We act as the direct link, ensuring nothing gets lost and every detail is understood.
              </p>
              <h3 className="text-xl text-black font-semibold mb-2">
                Physical Presence on the Ground
              </h3>
              <p className="text-gray-700">
                Many brands struggle because they can't be physically present to oversee production. Without proper monitoring, there's a risk of poor quality control, delayed timelines, or even unethical practices. We are their eyes and ears on-site, conducting real-time inspections and ensuring compliance with agreed-upon standards.
              </p>
            </div>
            <div>
              <img
                src={WhyBrand}
                alt="Why Brands Need Us"
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </motion.section>

        {/* Premium Service */}
        <motion.section
          className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center px-6 py-16"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <div>
            <img
              src={PremiumService}
              alt="Premium Service"
              className="rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-xl font-semibold  text-black mb-4">
              Premium Service & Quality Control
            </h2>
            <p className="text-gray-700 leading-relaxed">
                It's not just about making clothes—it's about making them exceptionally well. We don't just connect brands with factories; we take full ownership of the process, from fabric sourcing to final packaging, ensuring every piece meets the highest standards.
            </p>
          </div>
        </motion.section>

        {/* Timely Deliveries */}
        <motion.section
          className="bg-orange-50 py-16"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center px-6">
            <div>
              <h2 className="text-xl font-semibold text-black mb-4">
                Timely Deliveries
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Deadlines are everything in fashion. A delay of even a few weeks can mean missing an entire season, leading to financial loss. We coordinate every step meticulously to guarantee on-time deliveries.
              </p>
            </div>
            <div>
              <img
                src={TimelyDeliveries}
                alt="Timely Deliveries"
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </motion.section>

        {/* Our Promise */}
        <motion.section
          className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center px-6 py-16"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <div>
            <img
              src={OurPromise}
              alt="Our Promise"
              className="rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-[#BF5717] mb-4">
              Our Promise
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We didn't start this business just to be another middleman. We started because we saw a genuine need for a trustworthy, premium service agency that understands both the brands and the manufacturers. Our goal is simple: to make apparel production abroad a seamless, stress-free, and rewarding experience.
            </p>
          </div>
        </motion.section>

        <motion.div
          className="max-w-6xl mx-auto mb-10 text-center"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <h1 className="font-serif text-center text-xl md:text-2xl lg:text-3xl text-slate-600">
            By choosing us, brands don't just get a production partner—they get a team that truly cares. A team that ensures their vision is executed flawlessly, their quality expectations are exceeded, and their deadlines are met with precision.
            We are more than a service—we are the bridge that connects creativity with craftsmanship, vision with execution, and brands with endless opportunities.
          </h1>
        </motion.div>

        {/* Closing Section */}
        <motion.section
          className="bg-[#BF5717] text-white py-20 text-center"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-serif font-bold mb-10">
            Principles. Passion. Empowerment.
          </h2>
          <div className="flex flex-wrap justify-center gap-40">
            <img src={Img1} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
            <img src={Img2} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
            <img src={Img3} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
            <img src={Img4} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
          </div>
        </motion.section>
      </main>
      <Footer />
    </>
  );
};

export default OurStory;
